import { useState } from "react";
import { useQueryClient } from "react-query";
import { updateFreightQuotePrice } from "../../api/OrderSummaryApi";

function useFreightQuotePriceInput(
  quoteId: string,
  initialFreightQuotePrice: number | null | undefined,
  initialFreightQuotePriceUpdateRequired: boolean
) {
  const initialFreightQuotePriceAsString = initialFreightQuotePrice ? initialFreightQuotePrice.toString() : "0"
  const [freightQuotePriceUpdateRequired, setFreightQuotePriceUpdateRequired] = useState(initialFreightQuotePriceUpdateRequired)
  const [freightQuotePrice, setFreightQuotePrice] = useState<string>(initialFreightQuotePriceAsString);
  const [editFreightQuotePriceClicked, setEditFreightQuotePriceClicked] =
    useState(false);
  const [isUpdatingFreightQuotePrice, setIsUpdatingFreightQuotePrice] =
    useState(false);
  const queryClient = useQueryClient();

  const handleEditFreightQuotePriceClick = () => {
    setEditFreightQuotePriceClicked(true);
  };

  const handleConfirmFreightQuotePriceClick = () => {
    if (!freightQuotePrice || freightQuotePrice === "2222.00") return;
    setIsUpdatingFreightQuotePrice(true);
    setTimeout(async () => {
      try {
        await updateFreightQuotePrice(
          quoteId,
          parseFloat(freightQuotePrice),
        );
        setFreightQuotePriceUpdateRequired(false)
        queryClient.invalidateQueries("QuoteCart");
        queryClient.invalidateQueries("Cart");
      } catch (e) {
        console.error(e);
      } finally {
        setEditFreightQuotePriceClicked(false);
        setIsUpdatingFreightQuotePrice(false);
      }
    }, 1200);
  };

  const handleFreightQuotePriceChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { value } = event?.target;
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    //drop the leading 0 once a digit follows it so the user doesn't have to
    //backspace it first ("05" -> "5", while "0.50" is left alone)
    setFreightQuotePrice(value.replace(/^0+(?=\d)/, ""));
  };

  const handleFreightQuotePriceBlur = () => {
    setFreightQuotePrice((prev) => (prev ? Number(prev).toFixed(2) : prev));
  };

  const handleFreightQuotePriceClickAway = () => {
    if (!editFreightQuotePriceClicked || isUpdatingFreightQuotePrice)
      return;
    setEditFreightQuotePriceClicked(false);
    setFreightQuotePrice(initialFreightQuotePriceAsString);
  };

  return {
    freightQuotePrice,
    handleEditFreightQuotePriceClick,
    editFreightQuotePriceClicked,
    handleConfirmFreightQuotePriceClick,
    isUpdatingFreightQuotePrice,
    freightQuotePriceUpdateRequired,
    handleFreightQuotePriceChange,
    handleFreightQuotePriceBlur,
    handleFreightQuotePriceClickAway,
  };
}

export default useFreightQuotePriceInput;
